import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'dummy-skeleton',
  templateUrl: './dummy-skeleton.component.html',
  styleUrls: ['./dummy-skeleton.component.scss']
})
export class DummySkeletonComponent {
  @Input() itemQuantity: number = 11;
  @Input() show: boolean;
  @Input() listWidth: string = '800px';
  @Input() listHeight: string = '500px';
  @Input() itemWidth: string
  @Input() itemHeight: string = '66px';
  @Input() projectListSkeleton: boolean;
  @Input() cardSkeleton: boolean;
  datasource = Array.from(Array(this.itemQuantity).keys());
}
